import { lenisScroll } from 'helpers/smooth-scroll'

const backToTop = {
  el: {
    arFooter: document.querySelector<HTMLElement>('.footer-ar'),
    backToTop: document.querySelector<HTMLElement>('.back-to-top'),
    button: document.querySelector<HTMLElement>('.back-to-top__button'),
  },

  hasArFooter: !!document.querySelector('.footer-ar'),

  init(): void {
    this.el.button.addEventListener('click', this.scrollToTop.bind(this))
    window.addEventListener('scroll', this.toggleVisibility.bind(this))
    this.toggleVisibility()
  },

  scrollToTop(event): void {
    event.preventDefault()

    lenisScroll.scrollTo(0, {
      duration: 1.234,
      easing: (t) => (t < 0.5 ? 8 * t ** 4 : 1 - (-2 * t + 2) ** 4 / 2),
    })
  },

  toggleVisibility(): void {
    if (window.scrollY > window.innerHeight / 2) {
      this.el.backToTop.classList.add('back-to-top--active')

      if (this.hasArFooter && this.el.arFooter.getBoundingClientRect().top - window.innerHeight < 0) {
        this.el.backToTop.classList.remove('back-to-top--active')
      }
    } else {
      this.el.backToTop.classList.remove('back-to-top--active')
    }
  },
}

export default backToTop
